import LinkedText from "../components/LinkedText";
import {
    faYoutube,
    faSquareInstagram,
    faMastodon,
    faLinkedin,
    faGithub, faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import SocialLink from "../components/SocialLink";
import Root from "../layouts/Root";


export default function Home() {
    const rightContent = (
        <div>
            <p>AI & Data Engineer</p>
            <p>A man with a wife, two cats, and many interests.</p>
            
            <h1>Contact</h1>
            <p>
                Fastest way to reach me is via email: <LinkedText icon={faEnvelope} text={"cagri@mpospirit.com"} href={
                "mailto:cagri@mpospirit.com"}/>
            </p>
            
            <h1>Socials</h1>
                <SocialLink icon={faYoutube} text={"YouTube"} linkText={"@mpospirit"} href={"https://www.youtube.com/@mpospirit"}/>
                <br/>
                <SocialLink icon={faSquareInstagram} text={"Instagram"} linkText={"@mpospirit"} href={"https://www.instagram.com/mpospirit/"}/>
                <br/>
                <SocialLink icon={faTwitter} text={"Twitter"} linkText={"@mpospirit"} href={"https://x.com/mpospirit"}/>
                <br/>
                <SocialLink icon={faLinkedin} text={"LinkedIn"} linkText={"in/cagrigokpunar"} href={"https://www.linkedin.com/in/cagrigokpunar/"}/>
                <br/>
                <SocialLink icon={faGithub} text={"GitHub"} linkText={"@mpospirit"} href={"https://github.com/mpospirit"}/>
        </div>
)

return (
    <div className="home-page">
        <Root rightContent={rightContent}/>
    </div>
)
}

